import type { QueuedEditsReviewTask } from '@seen/core/models/tasks/standard/queuedEditsReviewTask'
import type { JSX } from 'react'
import { QueuedEditsReviewCard } from '#src/components/queued-edits/QueuedEditsReviewCard.tsx'

// Inbox surface for a QueuedEditsReviewTask: a thin wrapper around the
// Bundle-driven QueuedEditsReviewCard. The Bundle (referenced on Task.focus) is
// the self-contained review record — it carries the proposed entries and, on
// apply, the decisions + final committer. The card completes the orchestrating
// task and attributes the provenance itself by resolving the task from the
// bundle, so this wrapper only has to point it at the right bundle.
export function QueuedEditsReviewTaskCard({
  task,
}: {
  task: QueuedEditsReviewTask
}): JSX.Element {
  return (
    <QueuedEditsReviewCard bundleReference={task.proposedBundle?.reference} />
  )
}
